import type { ColumnView } from '../../domain'

import { Usecase } from './Usecase'

const isEmptyColumnView = ({ order, hidden, pinned, widths }: ColumnView): boolean =>
    [order, hidden, pinned].every((names) => names.length === 0) && Object.keys(widths).length === 0

/** Remembers how the user arranged each table's columns */
export class TableColumnViewUsecase extends Usecase {
    get (id: string): ColumnView {
        return this.columnViewPersistenceService.retrieve(id)
    }

    /** Table views come without stale names, so an empty view is the default one, which isn't stored */
    save (id: string, view: ColumnView): void {
        if (isEmptyColumnView(view)) {
            this.columnViewPersistenceService.drop(id)
        } else {
            this.columnViewPersistenceService.persist(id, view)
        }
    }
}
